import React from 'react'
import PropTypes from 'prop-types'

const ModalLink = ({
    ClassName,
    ButtonClasses,
    LinkText,
    SrText,
    TitleText,
    ToggleModal,
    UseIconOnly = false,
    Disabled = false,
    UseLoginLink = false,
    LoginPageLink = null
}) => {

    return (
        <div className="d-flex modal-link-wrapper">
            {UseLoginLink
                ? <a href={LoginPageLink} className={ButtonClasses} title={TitleText}>
                    <span className={ClassName + (UseIconOnly ? "" : " mr-2")}></span>
                    <span className="sr-only">{SrText}</span>
                    {!UseIconOnly && <span className="modal-link__text">{LinkText}</span>}
                </a>
                : <button className={ButtonClasses + " modal-link"} title={TitleText} disabled={Disabled}
                    onClick={e => {
                        e.preventDefault()
                        ToggleModal(true)
                    }}>
                    <span className={ClassName + (UseIconOnly ? "" : " mr-2")}></span>
                    <span className="sr-only">{SrText}</span>
                    {!UseIconOnly && <span className="modal-link__text">{LinkText}</span>}
                </button>
            }
        </div>
    );
};

ModalLink.propType = {
    ClassName: PropTypes.string,
    ButtonClasses: PropTypes.string,
    LinkText: PropTypes.string.isRequired,
    TitleText: PropTypes.string,
    SrText: PropTypes.string,
    Disabled: PropTypes.bool,
    ToggleModal: PropTypes.func.isRequired
};

export default ModalLink;